// extracted by mini-css-extract-plugin
module.exports = {"description":"styles-module--description--3Zguw"};